import request from '@/utils/request'

let Violation_contentApi = {

  /*违规内容列表*/
  list(data) {
    return request._post('/shop/plus.violation_content.Index/index', data);
},
/*下架*/
unShelve(data) {
    return request._post('/shop/plus.violation_content.Index/unShelve', data);
},
/*恢复*/
Shelve(data) {
    return request._post('/shop/plus.violation_content.Index/Shelve', data);
},

/*添加违规内容*/
add(data) {
    return request._post('/shop/plus.violation_content.Index/add', data);
},
/*修改违规内容*/
edit(data) {
    return request._post('/shop/plus.violation_content.Index/edit', data);
},
/*删除违规内容*/
del(data) {
    return request._post('/shop/plus.violation_content.Index/del', data);
},
/*违规内容详情*/
detail(data) {
  return request._post('/shop/plus.violation_content.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.violation_content.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.violation_content.Setting/getSetting', data, errorback);
    },
}
export default Violation_contentApi;



// WEBPACK FOOTER //
// ./src/api/violation_content.js